<template>
  <div v-show="customHidden === false">
    <footer
      class="d-flex justify-content-between align-items-center flex-wrap pagination-wrap"
      :class="{'mt-2' : small === true}"
    >
      <div class="my-1">Showing
        <strong>{{startResult}}</strong> -
        <strong>{{endResult}}</strong> of
        <strong>{{filtered.length}}</strong> results.
      </div>
      <div class="d-flex align-items-center">
        <button
          type="button"
          class="btn btn-primary mr-2"
          :class="{'btn-sm': small}"
          :disabled="!isPossible(-1)"
          @click="page -= 1"
        >
          <span>Prev. Page</span>
        </button>
        <div v-if="small === false">
          <span class="pagination-text">Page {{page + 1}} of {{possiblePages || 1}}</span>
        </div>
        <button
          type="button"
          class="btn btn-primary ml-2"
          :disabled="!isPossible(1)"
          @click="page += 1"
          :class="{'btn-sm': small}"
        >
          <span>Next Page</span>
        </button>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false
    },
    customHidden: {
      type: Boolean,
      default: false
    },
    filtered: {
      type: Array,
      required: true
    },
    customPageLength: Number
  },
  data() {
    return {
      pageLength: 0,
      page: 0
    };
  },
  watch: {
    possiblePages(newVal) {
      if (newVal < this.page + 1) {
        if (this.page !== 0) {
          this.page -= 1;
        }
      }
    },
    visibleResults(newVal) {
      //@TODO, this could be integrated into a set/get
      //computed property for visibleResults
      //Andrew P. 6 Dec 18
      this.$emit("input", newVal);
    },
    filtered() {
      //@TODO, Andrew P. 26 Nov 18. This will fire whenever
      //a socket updates a table. I'm unsure if this is a bug
      //though.
      this.page = 0;
    }
  },
  computed: {
    possiblePages() {
      return Math.ceil(this.filtered.length / this.pageLength);
    },
    startResult() {
      if (this.filtered.length === 0) {
        return 0;
      }

      return this.page * this.pageLength + 1;
    },
    endResult() {
      const maxPossible = (this.page + 1) * this.pageLength;

      if (maxPossible > this.filtered.length) {
        return this.filtered.length;
      }

      return maxPossible;
    },
    visibleResults() {
      const start = this.page * this.pageLength;

      return this.filtered.slice(start, start + this.pageLength);
    }
  },
  methods: {
    isPossible(change) {
      const current = this.page + 1;
      const intended = current + change;
      if (this.possiblePages < intended || intended < 1) {
        return false;
      }
      return true;
    },
    setPageLength() {
      this.pageLength = Math.floor((window.innerHeight - 367) / 40);
    }
  },
  created() {
    if (this.customPageLength) {
      this.pageLength = this.customPageLength;
    } else {
      this.setPageLength();
      window.addEventListener("resize", this.setPageLength);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-wrap{
  font-size: 0.875rem;

  .pagination-text{
    font-weight: 600;
  }
}
</style>

